import React from 'react';

import { Input, Section } from '@components';

type ColumnDefaultStyleFieldsProps = {
  defaultStyle?: DynamicColumnFieldStyle | null;
  onUpdate: (style: DynamicColumnFieldStyle) => void;
};

const ColumnDefaultStyleFields: React.FC<ColumnDefaultStyleFieldsProps> = ({
  defaultStyle,
  onUpdate,
}) => {
  const handleUpdate = (key: keyof DynamicColumnFieldStyle, value: string) => {
    onUpdate({
      ...defaultStyle,
      [key]: value || null,
    });
  };

  return (
    <Section
      title="Default Style"
      subtitle="Style applied when no specific value style matches"
    >
      <div className="flex flex-col gap-y-lg">
        <div className="flex flex-row gap-md">
          <div className="flex-1">
            <label className="text-small text-textLight font-normal mb-xs block">
              Text Color
            </label>
            <Input
              value={defaultStyle?.color || ''}
              onChange={val => handleUpdate('color', val)}
              placeholder="#000000"
              withBorder
            />
          </div>
          <div className="flex-1">
            <label className="text-small text-textLight font-normal mb-xs block">
              Font Size
            </label>
            <Input
              value={defaultStyle?.fontSize || ''}
              onChange={val => handleUpdate('fontSize', val)}
              placeholder="14px, 1.2rem"
              withBorder
            />
          </div>
        </div>

        <div className="flex flex-row gap-md">
          <div className="flex-1">
            <label className="text-small text-textLight font-normal mb-xs block">
              Font Weight
            </label>
            <Input
              value={defaultStyle?.fontWeight || ''}
              onChange={val => handleUpdate('fontWeight', val)}
              placeholder="normal, bold, 600"
              withBorder
            />
          </div>
          <div className="flex-1">
            <label className="text-small text-textLight font-normal mb-xs block">
              Background Color
            </label>
            <Input
              value={defaultStyle?.backgroundColor || ''}
              onChange={val => handleUpdate('backgroundColor', val)}
              placeholder="#ffffff"
              withBorder
            />
          </div>
        </div>

        <div className="flex-1">
          <label className="text-small text-textLight font-normal mb-xs block">
            Border Color
          </label>
          <Input
            value={defaultStyle?.borderColor || ''}
            onChange={val => handleUpdate('borderColor', val)}
            placeholder="#ffffff"
            withBorder
          />
        </div>
      </div>
    </Section>
  );
};

export default ColumnDefaultStyleFields;
